// src/admin/AdminCoupons.jsx
import { useEffect, useState } from "react";
import { doc, setDoc, deleteDoc, updateDoc } from "../services/mysqlStore";
import { db } from "../services/mysqlStore";
import { apiRequest } from "../services/apiClient";

export default function AdminCoupons() {
  const [coupons, setCoupons] = useState([]);
  const [loading, setLoading] = useState(true);

  const [code, setCode] = useState("");
  const [percent, setPercent] = useState("");
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState("");

  async function fetchCoupons() {
    setLoading(true);
    try {
      setCoupons(await apiRequest("/admin/coupons"));
    } catch (err) {
      console.error("Failed to load coupons:", err);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { fetchCoupons(); }, []);

  async function handleAddCoupon(e) {
    e.preventDefault();
    setFormError("");

    const cleanCode = code.trim().toUpperCase();
    const pct = Number(percent);

    if (!cleanCode) { setFormError("Please enter a coupon code."); return; }
    if (!pct || pct <= 0 || pct > 100) { setFormError("Discount must be a number between 1 and 100."); return; }

    const existing = coupons.find(c => c.id === cleanCode);
    if (existing) {
      const ok = window.confirm(`Coupon "${cleanCode}" already exists with ${existing.discountPercent}% off. Overwrite it with ${pct}%?`);
      if (!ok) return;
    }

    setSaving(true);
    try {
      await setDoc(doc(db, "coupons", cleanCode), {
        discountPercent: pct,
        active: true,
        createdAt: existing?.createdAt || new Date(),
      });
      setCode("");
      setPercent("");
      fetchCoupons();
    } catch (err) {
      console.error("Failed to save coupon:", err);
      setFormError("Something went wrong. Please try again.");
    } finally {
      setSaving(false);
    }
  }

  async function toggleActive(c) {
    await updateDoc(doc(db, "coupons", c.id), { active: !c.active });
    fetchCoupons();
  }

  async function handleDelete(id) {
    if (!window.confirm(`Delete coupon "${id}"? This cannot be undone.`)) return;
    await deleteDoc(doc(db, "coupons", id));
    fetchCoupons();
  }

  return (
    <div style={{ display: "flex", gap: 24, alignItems: "flex-start", flexWrap: "wrap" }}>

      {/* Left: Create coupon */}
      <div className="adm-card" style={{ flex: "1 1 320px", padding: 24 }}>
        <div className="adm-card-header" style={{ padding: 0, border: "none", marginBottom: 16 }}>
          <span className="adm-card-title">Create Coupon</span>
        </div>

        <form className="adm-form" onSubmit={handleAddCoupon}>
          <div className="adm-form-group">
            <label>Coupon Code</label>
            <input
              type="text"
              value={code}
              onChange={e => setCode(e.target.value)}
              placeholder="e.g. SAVE10"
              disabled={saving}
              style={{ textTransform: "uppercase" }}
            />
          </div>

          <div className="adm-form-group">
            <label>Discount Percentage</label>
            <input
              type="number"
              min="1"
              max="100"
              value={percent}
              onChange={e => setPercent(e.target.value)}
              placeholder="e.g. 10"
              disabled={saving}
            />
          </div>

          {formError && <p style={{ color: "#f87171", fontSize: 13, fontWeight: 600 }}>{formError}</p>}

          <button className="adm-btn adm-btn-primary" type="submit" disabled={saving}>
            {saving ? "Saving..." : "Add Coupon"}
          </button>
        </form>
      </div>

      {/* Right: Coupons list */}
      <div className="adm-card" style={{ flex: "1 1 420px" }}>
        <div className="adm-card-header">
          <span className="adm-card-title">Coupons ({coupons.length})</span>
        </div>

        {loading ? (
          <p style={{ padding: 24, color: "rgba(255,255,255,0.3)", fontSize: 13 }}>Loading coupons...</p>
        ) : coupons.length === 0 ? (
          <p style={{ padding: 24, color: "rgba(255,255,255,0.3)", fontSize: 13 }}>No coupons yet. Create one on the left.</p>
        ) : (
          <div className="adm-table-wrap">
            <table className="adm-table">
              <thead>
                <tr>
                  <th>Code</th>
                  <th>Discount</th>
                  <th>Orders using coupon</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {coupons.map(c => (
                  <tr key={c.id}>
                    <td><strong>{c.id}</strong></td>
                    <td>{c.discountPercent}% off</td>
                    <td>{Number(c.useCount || 0)}</td>
                    <td>
                      <button
                        className="adm-badge"
                        onClick={() => toggleActive(c)}
                        style={{
                          border: "none", cursor: "pointer",
                          background: c.active ? "rgba(74,222,128,0.15)" : "rgba(255,255,255,0.08)",
                          color: c.active ? "#4ade80" : "rgba(255,255,255,0.5)",
                        }}
                      >
                        {c.active ? "Active" : "Inactive"}
                      </button>
                    </td>
                    <td>
                      <button className="adm-btn adm-btn-sm adm-btn-danger" onClick={() => handleDelete(c.id)}>
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
